import React from 'react';
import '../assests/css/footer.css'

import android from "../assests/images/android.png"
import apple from "../assests/images/apple.png"


const Footer = () => (
  <footer className="footer container-fluid row">
    <div className="col-md-5"><small>Copyright &copy; {new Date().getFullYear()} LocusB, All Right Reserved</small></div>
    <div className="col" style={{textAlign: "end"}}>
    <img src={android} alt="android" height="25px" width="75px"/>&nbsp;&nbsp;&nbsp;
    <img src={apple} alt="apple" height="27px" width="75px"/>&nbsp;
    <small>Terms & Conditions</small>&nbsp;
    <small>Cookies Policy</small>&nbsp;
    <small>Privacy Policy</small>&nbsp;
    </div>
  </footer>
);

export default Footer;